/* eslint-disable @typescript-eslint/naming-convention */
import { type EarlyAccessConfig } from './interfaces';

export const DEFAULT_EARLY_ACCESS_CONFIG: EarlyAccessConfig = {
  'reply-suggestions': false,
  'live-assistant': false,
  'text-enhancement': false,
  'tag-suggestions': false,
};
